<template>
  <b-modal
    v-model="localIsActive"
    size="md"
    hide-footer
    hide-header-close
    no-close-on-esc
    no-close-on-backdrop
    @hide="onHide"
  >
    <template #modal-title>
      <h4 class="mb-0 text-white">Apertura de turno</h4>
    </template>

    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-form
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <div class="row">
          <div class="col-12">
            <validation-provider
              #default="validationContext"
              name="Worksation"
              rules="required"
            >
              <b-form-group
                label="Worksation"
                label-for="worksation"
              >
                <b-form-input
                  id="worksation"
                  v-model="userShift.workstation"
                  placeholder="Ingresar worksation"
                  :state="getValidationState(validationContext)"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="col-12">
            <validation-provider
              #default="validationContext"
              name="Líneas telefónicas"
              rules="required|telephone_lines"
            >
              <b-form-group
                label="Líneas telefónicas"
                label-for="telephone_lines"
              >
                <b-form-tags
                  input-id="telephone_lines"
                  v-model="userShift.telephone_lines"
                  tag-variant="primary"
                  placeholder="Ingresar números de teléfono"
                  :state="getValidationState(validationContext)"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
        </div>
        <div class="text-right">
          <b-button
            type="submit"
            variant="primary"
            :disabled="loading"
          >
            <span class="text-nowrap">Aceptar</span>
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import axios from '@/libs/axios';
import { useToast } from "vue-toastification/composition";
import { computed,ref } from '@vue/composition-api';
import { required } from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation';
import { ValidationObserver, ValidationProvider, extend} from 'vee-validate';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

extend('telephone_lines', {
  validate: value => value.every(telephone => /^\d+$/.test(telephone)),
  message: 'Las líneas telefónicas deben contener solo números.'
});

export default {
  props: {
    showUserShiftModal:{
      type: Boolean
    }
  },
  components:{
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      required
    }
  },
  setup(props, { emit }) {
    const resetData = () => {}

    //COMPOSABLES
    const {
      refFormObserver,
      getValidationState,
      resetForm
    } = formValidation(resetData);

    const toast = useToast();

    //DATA
    const loading = ref(false);

    const userShift = ref({
      id_user: null,
      workstation: null,
      telephone_lines: []
    });

    //COMPUTED
    const localIsActive = computed({
      get() {
        return props.showUserShiftModal;
      },
      set(value) {
        emit("update:isActive", value);
      },
    });

    //METHODS
    const onHide = () => {
      userShift.value = {
        id_user: null,
        workstation: null,
        telephone_lines: []
      }

      emit("update:isActive", false);
    }

    const onSubmit = async () => {
      loading.value = true;

      const payload = {
        workstation: userShift.value.workstation,
        telephone_lines: userShift.value.telephone_lines.join(',')
      }

      await axios.post('v1/user-shifts', payload).then(response => {
        const { data } = response;

        toast({
          component: ToastificationContent,
          props: {
            title: data.message,
            icon: 'CheckIcon',
            variant: 'success'
          }
        });

        localStorage.setItem('shift_register', false);
        onHide();
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
      .finally(() => {
        loading.value = false;
      });
    }


    return {
      refFormObserver,
      getValidationState,
      resetForm,

      loading,
      userShift,

      localIsActive,

      onHide,
      onSubmit,
      resetData
    }
  }
}
</script>
